import React from 'react';
import {some, every} from 'lodash'

import FixedFooter from "../components/fixedFooter"

export default class CateringDishesSummary extends React.Component {

  dishesForThisStepOnly() {
    return true;
  }

  render() {

    const amounts = this.props.amounts;
    const isEmpty = every(amounts, (groupAmounts) =>
      every(groupAmounts, amount => amount === 0)
    );

    let totalAmount = 0;
    Object.keys(amounts).map(dishName =>
      Object.keys(amounts[dishName]).map(variantName =>
        totalAmount += amounts[dishName][variantName]
      )
    );

    return (
      <FixedFooter>
        <div className="container tight">
          <div className="row">
            <div className="col-12 mt-2 mb-2 small">
              <h5 className="mt-2 mt-2">Sammanställning <span className="muted">({totalAmount*140}kr)</span></h5>
              {isEmpty && (
                <h6 style={{color:'rgba(255,255,255,.6)'}}>Ingeting är valt än...</h6>
              )}
              {Object.keys(amounts).map(dishName => (
                <div key={dishName}>
                {some(amounts[dishName], amount => amount > 0) && (
                  <>
                    <h6 className="mt-2 mb-0">{dishName}</h6>
                    {Object.keys(amounts[dishName]).map(variantName => (
                      <span key={dishName+variantName}>
                        {variantName !== Object.keys(amounts[dishName])[0] && (
                          <span className="mr-2">,</span>
                        )}
                        {amounts[dishName][variantName] > 0 && (
                          <span>
                            {variantName}:&nbsp;{amounts[dishName][variantName]}st
                          </span>
                        )}
                      </span>
                    ))}
                  </>
                )}
                </div>
              ))}
            </div>
            <div className="col-12 my-auto pt-2 pb-2">
              <div className="row">
                <div className="col-6">
                  <button className="btn btn-outline rounded btn-block" onClick={() => this.props.onPrev()}>&laquo; Tillbaka</button>
                </div>
                <div className="col-6">
                  {!this.props.isLastStep && (
                    <button className="btn btn-orange rounded btn-block" onClick={() => this.props.onNext()}>Nästa &raquo;</button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </FixedFooter>
    );
  }

}
